var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBridgingTheGapBetween(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6",
    "data-name": "Group 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.464,
    height: 88.331,
    viewBox: "0 0 85.464 88.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 85.464,
    height: 88.331,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M48.571,216.975a13.111,13.111,0,0,1,6.336,4.644l3.809-1.975c.2-.276-1.27-1.472-1.514-1.775a9.088,9.088,0,1,1,13.968.438,9.856,9.856,0,0,1-1.127.969c-.15.141-.162.122-.113.369,4.451,1.509,7.654,5.49,9.069,9.888,2.619-.035,5.338.028,6.321,2.934a22.7,22.7,0,0,1,.273,6.136,2.662,2.662,0,0,1-2.574,2.587H3.09A2.662,2.662,0,0,1,.515,238.6a22.688,22.688,0,0,1,.273-6.136c.983-2.907,3.7-2.969,6.321-2.934,1.415-4.4,4.618-8.379,9.069-9.888.049-.246.037-.227-.113-.369a9.031,9.031,0,0,1,10.135-14.9c5.826,3.243,6.055,11.162,1.014,15.27l3.987,1.974a13.11,13.11,0,0,1,6.336-4.644c-3.958-3.4-4.892-9.125-1.419-13.253a9.112,9.112,0,0,1,15.437,2.707c1.469,4.059.073,7.757-2.983,10.546m-6.81-13.482a6.555,6.555,0,0,0-4.707,4.37A6.259,6.259,0,0,0,46.6,214.74c5.455-3.693,2.1-12.329-4.84-11.247m22.561,2.55c-8.155,0-8.151,12.44,0,12.434,8.271-.006,8.266-12.43,0-12.434m-43.919.119c-6.758,1.053-6.444,12.189,1.234,12.347,8.694.179,8.311-13.834-1.234-12.347M49.8,229.6a13.6,13.6,0,0,1,1.544-3.706c.293-.5,1.579-1.99,1.48-2.38a25.019,25.019,0,0,0-2.31-2.335A12.53,12.53,0,0,0,35.7,221.1a22.843,22.843,0,0,0-2.414,2.409c-.1.409.856,1.4,1.123,1.847a15.563,15.563,0,0,1,1.909,4.232Zm-16.535.018a12.212,12.212,0,0,0-17.143-6.91c-2.566,1.293-5.246,4.055-5.816,6.91Zm42.538,0c-.529-2.7-2.989-5.324-5.354-6.66-6.615-3.738-15.353-.595-17.606,6.66Zm-72.439,4c-.238,1.339.176,3.3,0,4.716H82.744v-4.716c0-.453-.938-1.321-1.5-1.169H4.865a1.584,1.584,0,0,0-1.5,1.169",
    transform: "translate(-0.328 -152.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M23.681,29.946l-3.53,1.9-.03,14.564a3.576,3.576,0,0,1-3.29,3.474c-4.262-.278-8.972.366-13.178.005A3.449,3.449,0,0,1,.182,46.414c.469-7.124-.616-15.02.029-22.053a10.347,10.347,0,0,1,4.957-7.854C-.02,12.609.812,4.328,6.955,1.915c9.291-3.648,15.879,8.547,8.187,14.591a11.249,11.249,0,0,1,4.187,4.9L23.6,19.268c.71-6.781-2.4-16.425,6.315-18.959C45.784-.305,61.779.213,77.7.046a8.426,8.426,0,0,1,7.573,7.911c.609,7.766-.45,16.339-.029,24.189a8.413,8.413,0,0,1-7.357,7.594l-47.153-.026c-4.731-.811-7.466-5.1-7.05-9.769m2.878-1.574c-.413,3.713.35,7.659,4.524,8.5l46.268.023a5.4,5.4,0,0,0,5.062-5.083c.687-7.525-.514-16.045.009-23.675a5.645,5.645,0,0,0-4.9-5.242l-45.747-.01c-3.167.262-5.019,2.524-5.25,5.607-.226,3.015.183,6.308.006,9.352a4.875,4.875,0,0,1,4.006,1.24l8.74-10.121c1.39-.637,2.507.124,2.2,1.668a6.6,6.6,0,0,1-.973,1.342c-1.052,1.333-8.338,9.249-8.408,9.9-.028.258.166.584.143.869-.292,3.569-2.947,4.2-5.68,5.636M9.223,4.183C2.449,5.1,3.3,16.194,11.119,15.157c6.721-.891,5.742-12-1.9-10.974m8.052,42.225V33.326c-2.11.812-3.462,2.1-5.872,1.334a4.747,4.747,0,0,1-3.209-5.165,1.483,1.483,0,0,1,2.486-1.054c.6.562.267,1.412.375,2.117a1.839,1.839,0,0,0,2.268,1.4l15.408-7.915c1.624-1.262-.174-4.159-2.072-3.139l-9.2,4.764C17.1,22.6,15.676,19.6,12.592,18.52A7.122,7.122,0,0,0,3.039,24.7c-.624,6.79.469,14.48-.013,21.365-.024.648.17.894.8.977,3.823.5,8.715-.4,12.656,0l.434-.1a1.853,1.853,0,0,0,.356-.534",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M183.3,61.929a1.629,1.629,0,0,1,1.092-.419l25.823.008c1.866.215,1.672,2.64-.178,2.856H184.4a1.5,1.5,0,0,1-1.1-2.445",
    transform: "translate(-139.457 -46.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M209.222,126.718l20.074-.047a1.431,1.431,0,0,1,.177,2.855l-20.734-.1a1.452,1.452,0,0,1,.483-2.712",
    transform: "translate(-158.533 -96.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M175.849,94.661l17.667.055c1.532,1.272.6,2.575-1.155,2.752-4.928.5-10.647-.367-15.661,0-1.753.032-2.454-2.075-.851-2.81",
    transform: "translate(-133.352 -72.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M201.792,30.568a1.642,1.642,0,0,1-.915.42c-4.166-.371-9.112.468-13.182,0a1.432,1.432,0,0,1-.164-2.841c4.148.34,9.116-.49,13.164-.015a1.468,1.468,0,0,1,1.1,2.44",
    transform: "translate(-142.036 -21.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M276.064,30.729a1.666,1.666,0,0,1-.915.42,39.608,39.608,0,0,1-6.048-.018,1.42,1.42,0,0,1,.184-2.821,36.29,36.29,0,0,1,5.847-.006,1.465,1.465,0,0,1,.932,2.426",
    transform: "translate(-204.205 -21.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M159.838,126.476a31.683,31.683,0,0,1,5.932.035,1.438,1.438,0,0,1,.073,2.767,55.83,55.83,0,0,1-6.367-.033,1.456,1.456,0,0,1,.362-2.769",
    transform: "translate(-120.896 -96.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M270.236,94.22c1.674-.384,4.527.175,6.332,0a1.425,1.425,0,0,1,.222,2.462c-.839.553-6.278.566-7.031-.1-.652-.578-.513-2.132.477-2.359",
    transform: "translate(-205.313 -71.712)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgingTheGapBetween);
export default __webpack_public_path__ + "static/media/bridging_the_gap_between.84ebfda4c39996fe99dc015c97e96826.svg";
export { ForwardRef as ReactComponent };